module.exports = __webpack_public_path__ + "static/img/areaA-14.f13051e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-14.png
// module id = 934
// module chunks = 1